import { STATE_LRR_SOURCES_MAP, STATE_TO_STATE_COURT_MAP, getFederalCourtIdsByState, getJurisdictionLabel } from '@/jurisdiction-mappings/jurisdiction-maps'

/**
 * StateCheckboxOption is a type that represents a state checkbox option.
 * It is used to display a state checkbox option in the source dialog.
 * It contains the state jurisdiction codes, lrr jurisdiction codes, and federal court ids.
 */
export type StateCheckboxOption = {
  id: string
  label: string
  value: {
    stateJurisdictionCodes: string[]
    lrrJurisdictionCodes: string[]
    federalCourtJurisdictionCodes: string[]
  }
}

/**
 * Generates options for state selection, where each option contains state court IDs, LRR sources, and federal court IDs for that state.
 *
 * @returns Array of StateCheckboxOption objects for use in checkbox or radio components.
 */
export function getStateCheckboxOptions(): StateCheckboxOption[] {
  const statesToProcess = Object.keys(STATE_TO_STATE_COURT_MAP)

  return statesToProcess
    .filter((state) => STATE_TO_STATE_COURT_MAP[state] && STATE_TO_STATE_COURT_MAP[state].length > 0)
    .map((state) => ({
      id: state,
      label: getJurisdictionLabel(state),
      value: {
        stateJurisdictionCodes: STATE_TO_STATE_COURT_MAP[state] || [],
        lrrJurisdictionCodes: STATE_LRR_SOURCES_MAP[state] || [],
        federalCourtJurisdictionCodes: getFederalCourtIdsByState(state),
      },
    }))
}
